import { formatDate } from '../../../helpers/genericHelper';
import CustomText from '../../CustomText';

function RefferalPayouts({ refData = [], loading }) {
  return (
    <div className="ant-list-box table-responsive" style={{ maxHeight: 400 }}>
      <table className="width-100">
        <thead>
          <tr>
            <th>Status</th>
            <th>Payout Type ID</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {refData && refData.map((data) => {
            return (
              <tr>
                <td>
                  <CustomText
                    dataSet={data}
                    property1={'status'}
                  />
                </td>
                <td>
                  <CustomText
                    dataSet={data}
                    property1={'payoutTypeId'}
                  />
                </td>
                <td>
                  <CustomText
                    dataSet={data}
                    property1={'date'}
                    formatter={formatDate}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default RefferalPayouts;
